<section class="intro">
  <div class="intro-visual reveal">
    <img src="/exterior/new/facade1.webp" alt="Acacia exterior highlight" class="intro-image" />
  </div>

  <div class="intro-copy reveal reveal-delay-2">
    <img src="/backgrounds/twig.webp" alt="" class="intro-copy-twig" aria-hidden="true" />
    <h2 class="intro-headline">
      A Landmark Statement  <br>In Kilimani<br /> </h2>
    <p class="intro-body">
      ACACIA is a bold expression of refined urban living where the spirit of a luxury safari lodge is
      reimagined for the city. Thoughtfully designed 1 and 2 bedroom suites are complemented by a curated
      collection of amenities and experiences, from tranquil gardens and elevated dining to a rooftop
      sanctuary with sweeping views.
    </p>
  </div>

  <img src="/backgrounds/twig.webp" alt="" class="intro-twig" aria-hidden="true" />
</section>
